<template>
  <div>
    <page-main
      ref="main"
      :disabled="disabled"
      :loading="loading"
      :tableData="tableData"
      @add="addProcessVisible = true"
      @openChooseTechSpec="chooseVisible = true"
    >
    </page-main>

    <AddProcess
      :visible.sync="addProcessVisible"
      :title="$l('form_label_choose_tech') ||'产品分类工序字典选择'"
      @confirm="dictionaryConfirm"
    />
    <ChooseOrderTechSpec
      v-if="chooseVisible"
      :visible.sync="chooseVisible"
      :title="$l('form_label_choose_techPricing') || '选择工时工价'"
      @confirm="chooseConfirm"
      :orderTechPricingSpecCode="orderTechPricingSpecCode"
    />
  </div>
</template>
<script>
import AddProcess from './add-process'
import ChooseOrderTechSpec from '../choose-order-tech-spec'
import PageMain from './main.vue'
import EditLoading from '@/mixins/edit-loading'
import { cloneDeep } from 'lodash'
export default {
  components: { PageMain, AddProcess, ChooseOrderTechSpec },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    orderTechPricingSpecCode: { type: String, default: '' },
    techList: { type: Array, default: () => [] },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      addProcessVisible: false,
      chooseVisible: false,
    }
  },
  mounted() {},
  watch: {
    techList: {
      handler() {
        this.tableData = cloneDeep(this.techList || [])
      },
      immediate: true,
    },
  },
  methods: {
    getData() {
      return this.$refs.main.getTableData()
    },
    async validate() {
      return await this.$refs.main.validate()
    },
    openChooseTechSpec() {
      this.chooseVisible = true
    },
    chooseConfirm(data) {
      if (!data || !data.techList || !data.techList.length) return
      this.$refs.main.setCopyTableData(data.techList)
      this.chooseVisible = false
    },
    async dictionaryConfirm(data) {
      this.$refs.main.setTableData(data)
      this.addProcessVisible = false
    },
  },
}
</script>
